module.exports = __webpack_public_path__ + "img/img6.151bdbd3.png";